import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormFieldBase } from '../../../classes/form-field-base';
import { CommonModule } from '@angular/common';
import { PhoneMaskDirective } from '../../../directives/phone-mask.directive';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';

@Component({
    selector: 'app-form-field',
    standalone: true,
    templateUrl: './dynamic-form-field.component.html',
    styleUrls: ['./dynamic-form-field.component.css'],
    providers: [],
    imports: [
        ReactiveFormsModule,
        // NgSwitch,
        // NgSwitchCase,
        CommonModule,
        PhoneMaskDirective,
        NgxMaskDirective
    ]
})
export class DynamicFormFieldComponent {

  @Input() formField!: FormFieldBase<string>;
  @Input() form!: FormGroup;
  @Output() emitCheckedEvent = new EventEmitter<{srcElement: string, checked: boolean}>();

  get isValid() {
    // return this.form.controls[this.formField.key].valid;
    return this.form.get(this.formField.key)?.valid;
  }

  onCheckboxChange(e: any) {
    this.emitCheckedEvent.emit({srcElement: e.srcElement.id, checked: e.target.checked});
    if (e.target.checked) {
      // console.log(e.srcElement.id, 'checked');
    }
    else {
      // console.log(e.srcElement.id, 'unchecked');
    }
  }
}
